
import dayjs from 'dayjs'
import { computed } from 'vue'
import { useStore } from 'vuex'
export default function useTime (quarter) {
  const store = useStore()
  const year = computed(() =>
    Number(
      (store.state.yearCycles[store.state.activeYearIndex] || [])[0]
        ?.displayName || dayjs().year()
    )
  )

  const startDayOfQuarter = computed(() =>
    dayjs()
      .year(year.value)
      .quarter(quarter.value)
      .startOf('Q')
  )

  const lastDayOfQuarter = computed(() =>
    dayjs()
      .year(year.value)
      .quarter(quarter.value)
      .endOf('Q')
  )

  const firstFriday = computed(() => {
    const fridayOfTheWeekOfStartDayOfQuarter = startDayOfQuarter.value.day(5)
    return fridayOfTheWeekOfStartDayOfQuarter.isBefore(
      startDayOfQuarter.value
    )
      ? fridayOfTheWeekOfStartDayOfQuarter.add(1, 'w')
      : fridayOfTheWeekOfStartDayOfQuarter
  })

  const lastFriday = computed(() => {
    const thisFriday = dayjs().day(5)
    const fridayOfTheWeekOfLastDayOfQuarter = lastDayOfQuarter.value.day(5)
    const lastFriday = fridayOfTheWeekOfLastDayOfQuarter.isAfter(
      lastDayOfQuarter.value
    )
      ? fridayOfTheWeekOfLastDayOfQuarter.subtract(1, 'w')
      : fridayOfTheWeekOfLastDayOfQuarter
    return lastFriday.isAfter(thisFriday) ? thisFriday : lastFriday
  })
  return {
    startDayOfQuarter,
    lastDayOfQuarter,
    firstFriday,
    lastFriday
  }
}
